var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.9981 20.7058L16.2579 14.9657C17.749 13.142 18.4821 10.8151 18.3056 8.46609C18.1291 6.11711 17.0565 3.92582 15.3097 2.34547C13.5629 0.765132 11.2755 -0.0833514 8.9206 -0.0244722C6.56572 0.034407 4.32357 0.996144 2.6579 2.66181C0.992238 4.32748 0.0305007 6.56963 -0.0283785 8.9245C-0.0872576 11.2794 0.761226 13.5668 2.34157 15.3136C3.92191 17.0604 6.1132 18.133 8.46219 18.3095C10.8112 18.486 13.1381 17.7529 14.9618 16.2618L20.7019 22.002L21.9981 20.7058ZM9.16476 16.502C7.71436 16.502 6.29654 16.0719 5.09058 15.2661C3.88462 14.4603 2.94468 13.315 2.38964 11.975C1.8346 10.635 1.68937 9.16053 1.97233 7.738C2.25529 6.31547 2.95372 5.0088 3.97931 3.98321C5.00489 2.95763 6.31157 2.2592 7.7341 1.97624C9.15662 1.69328 10.6311 1.8385 11.9711 2.39355C13.3111 2.94859 14.4564 3.88852 15.2622 5.09448C16.068 6.30044 16.4981 7.71827 16.4981 9.16866C16.4959 11.1129 15.7226 12.9769 14.3478 14.3517C12.973 15.7265 11.109 16.4998 9.16476 16.502Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0143aa40e64a5435feb492e89f5e42db.svg";
export { ForwardRef as ReactComponent };